import { render, staticRenderFns } from "./CampaignView.vue?vue&type=template&id=1c1edf8e&scoped=true"
import script from "./CampaignView.vue?vue&type=script&lang=ts"
export * from "./CampaignView.vue?vue&type=script&lang=ts"
import style0 from "./CampaignView.vue?vue&type=style&index=0&id=1c1edf8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1edf8e",
  null
  
)

export default component.exports